import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import styled from 'styled-components';
import { compose } from "redux";
import {Grid, Fade} from "@material-ui/core";
import Logo from "lib/images/LB_logo.svg";
import { getSplashScreenMessages } from "store/state/splashScreen";


const StyledLanding = styled.div`
position:fixed;
padding-top:50px;
margin:0;
top:0;
left:0;
width: 100%;
height: 100%;
align-items: center;
background-color: rgb(85, 85, 95);
justify-content: center;
overflow: hidden;
z-index: 10000;
transition: all 0.3s ease;
`;

const StyledMessage = styled.div`
margin-top: 25px;
color: white;
text-align: center;
`;

const Outer = styled.div`
  display: table;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`

const Middle = styled.div`
  display: table-cell;
  vertical-align: middle;
`

const Inner = styled.div`
  margin-left: auto;
  margin-right: auto;
`



class SplashScreen extends Component {
  state = { 
    messages: [
      {value:"Please Wait..."},
      {value:"The Monkeys are working"}
    ] ,
    message: "Please Wait...",
    currentMessageIndex: 0
  };
  
  componentDidMount() {    
    if(this.props.splashScreenMessages.length <=1 )
      this.props.getSplashScreenMessages(); 
    else {
      this.setState({messages: this.props.splashScreenMessages});
      this.cycleMessages(-1); 
    }
  }
  
  componentDidUpdate(prevProps){
  if(this.props.splashScreenMessages && prevProps.splashScreenMessages != this.props.splashScreenMessages){
      this.setState({messages: this.props.splashScreenMessages});
      this.cycleMessages(-1);      
    } 
  }

  cycleMessages = (cycleNum) => {
    let nextMessageIndex = cycleNum+1;
    if(this.state.messages.length === 0 || !this.state.messages[nextMessageIndex])
      nextMessageIndex = 0;
    
    this.setState({
      currentMessageIndex: nextMessageIndex
    });
    
    cycleNum = cycleNum+1;
    if(this.props.loading && cycleNum < 6){
      setTimeout(() => this.cycleMessages(cycleNum), 2000);
    }
  }

  render() {
    return (
      <StyledLanding>
        <Outer>
          <Middle>
            <Inner>
                  <Grid container alignContent="space-between">
                    <Grid item xs={12}><Fade in={this.props.loading}><StyledMessage><img src={Logo} id="homeLogo" className="Splash-logo" alt="logo" /></StyledMessage></Fade></Grid>
                    <Grid item xs={12}>
                      {this.state.messages.map( (item, i) => {
                        return (<StyledMessage key={'m-'+ i} hidden={this.state.currentMessageIndex !== i} className="Splash-logo-message">{item.value}</StyledMessage>)
                      })}
                      </Grid>
                  </Grid>
            </Inner>
          </Middle>
        </Outer>
      </StyledLanding>
    );
  }
}

const mapStateToProps = ({ authentication, splashScreen }) => ({
  authentication,
  splashScreenMessages: !splashScreen || splashScreen.splashScreenMessages
});

export default compose(
  connect(
      mapStateToProps,
    {getSplashScreenMessages}),
)(SplashScreen);
